import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('servicePackageVolume', servicePackageVolume);

function servicePackageVolume(splitService, $filter) {
  return function servicePackageVolumeFilter(packages, enableUnitDisplay) {

    const countAsTotal = splitService.getPackageVolumeIsTotal();
    const itemsVolumeSum = _.reduce(packages, (sum, i) => {
      let itemVolume: number;
      if (!_.isUndefined(_.get(i, 'dimensions.cube'))) {
        itemVolume = i.dimensions.cube;
      } else {
        itemVolume = i.volume;
      }
      return countAsTotal ? sum + itemVolume : sum + itemVolume * _.get(i, 'count', 0);
    }, 0);

    return itemsVolumeSum ? $filter('bringozVolume')(itemsVolumeSum, enableUnitDisplay) : '--';
  }
}
